import {IFavoriteListItemDTO} from "../types/IFavoriteListItemDTO";

export const isExternalFavorite = (favorite: IFavoriteListItemDTO) => Boolean(favorite.external_property);
import {IFavoriteListItemDTO} from "../types/IFavoriteListItemDTO";

export const isExternalFavorite = (favorite: IFavoriteListItemDTO) => Boolean(favorite.external_property);
